import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import Cookies from 'js-cookie';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { configuration } from '../../../network';
import { UserApi } from '../../../network/rest/apis/UserApi';
import ApiErrorHandler from '../../../utils/ApiErrorHandler';
import { links, translations } from '../../../utils/staticContent';
import useColorMode from '../../components/ToggleColorMode/useColorMode';

function Login() {
    const { theme } = useColorMode();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    return (
        <ThemeProvider theme={theme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        {translations.login}
                    </Typography>
                    <Box
                        component="form"
                        noValidate
                        sx={{ mt: 1 }}
                        onSubmit={async (e) => {
                            e.preventDefault();
                            const userAPI = new UserApi(configuration.config);
                            try {
                                const res = await userAPI.loginApiV1UserLoginPost({
                                    username,
                                    password,
                                });
                                if (res) {
                                    Cookies.set('accessToken', res.access_token, {
                                        secure: window.location.origin.includes('localhost')
                                            ? false
                                            : true,
                                    });
                                    navigate(`/admin${links.events}`);
                                }
                            } catch (e) {
                                const error = ApiErrorHandler(e);
                                setError(error);
                            }
                        }}
                    >
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="email"
                            label={translations.username}
                            name="email"
                            autoComplete="email"
                            autoFocus
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label={translations.password}
                            type="password"
                            id="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                            disabled={!username || !password}
                        >
                            {translations.login}
                        </Button>
                        <Typography component="span" color="red">
                            {error}
                        </Typography>
                    </Box>
                </Box>
            </Container>
        </ThemeProvider>
    );
}

export default Login;
